import { useCallback, useEffect, useState } from "react";
import {
  obtenerConfiguracionTiendaSetup,
  actualizarConfiguracionTiendaSetup,
} from "../../../services/usuarios_tienda/tiendaSetup";

function SetupTabConfiguracion() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setMsg(null);
    const res = await obtenerConfiguracionTiendaSetup();
    if (res.ok) setData(res.data || {});
    else setMsg({ type: "err", text: res.message });
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const setField = (key, value) => {
    setData((prev) => ({ ...(prev || {}), [key]: value }));
  };

  const guardar = async () => {
    if (!data) return;
    setSaving(true);
    setMsg(null);
    const res = await actualizarConfiguracionTiendaSetup({
      modo_pagos_checkout: data.modo_pagos_checkout,
      moneda_codigo: data.moneda_codigo,
      moneda_simbolo: data.moneda_simbolo,
      nombre_interno: data.nombre_interno,
      nombre_comercial: data.nombre_comercial,
      checkout_requiere_codigo_postal: data.checkout_requiere_codigo_postal ? 1 : 0,
      permite_checkout_invitado: data.permite_checkout_invitado ? 1 : 0,
      usa_inventario: data.usa_inventario ? 1 : 0,
      tiempo_reserva_minutos: Number(data.tiempo_reserva_minutos ?? 30),
      estado: data.estado ? 1 : 0,
    });
    if (res.ok) setMsg({ type: "ok", text: res.message || "Listo." });
    else setMsg({ type: "err", text: res.message });
    setSaving(false);
  };

  if (loading) {
    return <div className="tienda-setup-loading">Cargando…</div>;
  }

  if (!data || !Object.keys(data).length) {
    return <div className="tienda-setup-empty">No hay configuración para esta tienda.</div>;
  }

  return (
    <div className="tienda-setup-grid">
      <div className="tienda-setup-field">
      </div>
      <div className="tienda-setup-field" style={{ marginTop: 10 }}>
        <label>Moneda (código)</label>
        <input value={data.moneda_codigo || ""} onChange={(e) => setField("moneda_codigo", e.target.value)} />
      </div>
      <div className="tienda-setup-field" style={{ marginTop: 10 }}>
        <label>Símbolo</label>
        <input value={data.moneda_simbolo || ""} onChange={(e) => setField("moneda_simbolo", e.target.value)} />
      </div>
      <div className="tienda-setup-field" style={{ marginTop: 10 }}>
        <label>Tiempo reserva carrito (minutos)</label>
        <input
          type="number"
          value={data.tiempo_reserva_minutos ?? 30}
          onChange={(e) => setField("tiempo_reserva_minutos", e.target.value)}
        />
      </div>
      <div className="tienda-setup-field" style={{ marginTop: 14 }}>
        <label className="tienda-setup-check">
          <input
            type="checkbox"
            checked={!!Number(data.checkout_requiere_codigo_postal)}
            onChange={(e) => setField("checkout_requiere_codigo_postal", e.target.checked ? 1 : 0)}
          />
          Checkout requiere código postal
        </label>
      </div>
      <div className="tienda-setup-field" style={{ marginTop: 8 }}>
        <label className="tienda-setup-check">
          <input
            type="checkbox"
            checked={!!Number(data.permite_checkout_invitado)}
            onChange={(e) => setField("permite_checkout_invitado", e.target.checked ? 1 : 0)}
          />
          Permite checkout invitado
        </label>
      </div>
      <div className="tienda-setup-field" style={{ marginTop: 8 }}>
        <label className="tienda-setup-check">
          <input
            type="checkbox"
            checked={!!Number(data.usa_inventario ?? 1)}
            onChange={(e) => setField("usa_inventario", e.target.checked ? 1 : 0)}
          />
          Usa inventario
        </label>
      </div>
      
      <div className="tienda-setup-actions">
        <button type="button" className="tienda-setup-btn" disabled={saving} onClick={guardar}>
          {saving ? "Guardando…" : "Guardar cambios"}
        </button>
        {msg && (
          <p
            className={`tienda-setup-msg ${msg.type === "ok" ? "tienda-setup-msg-ok" : "tienda-setup-msg-err"}`}
          >
            {msg.text}
          </p>
        )}
      </div>
    </div>
  );
}

export default SetupTabConfiguracion;
